<div class="container">
  <div class="door-list mt-3 mb-3" *ngIf="doors.length > 0">
    <table class="table table-striped table-responsive-lg">
      <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Name</th>
        <th></th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let door of doors">
        <th scope="row">{{door.id}}</th>
        <td>{{door.name}}</td>
        <td class="text-center">
          <button type="button" class="btn btn-light" (click)="editDoor(door)" [disabled]="editorVisible">
            <i class="fas fa-pencil"></i>
          </button>
        </td>
        <td>
          <button type="button" class="btn btn-danger" (click)="deleteDoor(door.id)" [disabled]="editorVisible">
            <i class="fas fa-trash"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="text-center mb-3">
    <button type="button" class="btn btn-primary" [disabled]="editorVisible" (click)="addDoor()">Add new</button>
  </div>

  <div *ngIf="editorVisible">
    <form [formGroup]="doorForm">
      <div class="mt-5">
        <div class="form-row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Name</label>
            </div>
            <div class="form-row">
              <div class="col">
                <input type="text" formControlName="name" class="form-control" placeholder="name"/>
              </div>
            </div>
          </div>
        </div>
        <div class="form-row mt-4 text-center">
          <div class="col-md-6">
            <button type="button" class="btn btn-primary" (click)="saveDoor()">Save</button>
          </div>
          <div class="col-md-6">
            <button type="button" class="btn btn-secondary" (click)="hideEditor()">Cancel</button>
          </div>
        </div>
        <div class="form-row mt-4">
          <div class="alert alert-danger" *ngIf="errorMessage">Error: {{errorMessage}}</div>
        </div>
      </div>
    </form>
  </div>
</div>
